/* global Office Word */

// Office.js helpers wrapped in promises with friendlier APIs.

export async function insertHtmlAtSelection(html: string): Promise<void> {
  await Word.run(async (context) => {
    context.document.getSelection().insertHtml(html, Word.InsertLocation.replace);
    await context.sync();
  });
}

export async function replaceBodyWithHtml(html: string): Promise<void> {
  await Word.run(async (context) => {
    context.document.body.insertHtml(html, Word.InsertLocation.replace);
    await context.sync();
  });
}

export async function insertDocxBase64(base64: string): Promise<void> {
  await Word.run(async (context) => {
    context.document.body.insertFileFromBase64(base64, Word.InsertLocation.replace);
    await context.sync();
  });
}

// Reads the current document as a base64-encoded DOCX. Returns the base64
// payload of the entire document.
export async function getDocumentAsBase64Docx(): Promise<string> {
  return new Promise((resolve, reject) => {
    Office.context.document.getFileAsync(
      Office.FileType.Compressed,
      { sliceSize: 65536 },
      (result) => {
        if (result.status !== Office.AsyncResultStatus.Succeeded) {
          reject(new Error(result.error?.message || "Failed to read document"));
          return;
        }
        const file = result.value;
        const slices: Uint8Array[] = [];
        let received = 0;

        const next = (index: number) => {
          file.getSliceAsync(index, (sliceResult) => {
            if (sliceResult.status !== Office.AsyncResultStatus.Succeeded) {
              file.closeAsync();
              reject(new Error(sliceResult.error?.message || "Failed to read slice"));
              return;
            }
            slices[index] = new Uint8Array(sliceResult.value.data as ArrayBuffer);
            received += 1;
            if (received < file.sliceCount) {
              next(index + 1);
            } else {
              file.closeAsync();
              resolve(uint8ArraysToBase64(slices));
            }
          });
        };

        if (file.sliceCount === 0) {
          file.closeAsync();
          resolve("");
        } else {
          next(0);
        }
      }
    );
  });
}

function uint8ArraysToBase64(parts: Uint8Array[]): string {
  let binary = "";
  for (const part of parts) {
    for (let i = 0; i < part.length; i += 1) {
      binary += String.fromCharCode(part[i]);
    }
  }
  return btoa(binary);
}
